import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

import ShopPay from '../components/common/ShopPay'

const route = new Router({
  mode: 'history', //以便去掉网址中的#
  routes: [
    // 十二宫格
    {
      path: '/srseenAdvertising',
      name: 'SrseenAdvertising',
      component: () => import('../components/activity/SreenAdvertising')
      // component: resolve => require(["../components/Home"], resolve),
    },
    {
      path: '/',
      name: 'Home',
      component: () => import('../components/Home'),
      // meta: {
      //   keepAlive: true // 需要缓存
      // }
      // component: resolve => require(["../components/Home"], resolve),
    },
    {

      path: '/active/page/tykj',
      name: 'Tykj',
      component: resolve => require(["../components/activePage/tykjMoudle/index"], resolve),
    },
    {
      path: '/active/page/tykj/items',
      name: 'Tykj',
      component: resolve => require(["../components/activePage/tykjMoudle/items"], resolve),
    },
    {
      path: '/test',
      name: 'Test',
      component: resolve => require(["../components/activePage/test"], resolve),
    },
    {
      path: '/tencent',
      name: 'Tencent',
      component: resolve => require(["../components/activePage/yyb"], resolve),
    },
    {
      path: '/active/page/yybfss',
      name: 'Tencent',
      component: resolve => require(["../components/activePage/yybFss"], resolve),
    },
    {
      path: '/active/page/yybmnej',
      name: 'Tencent',
      component: resolve => require(["../components/activePage/yybMnej"], resolve),
    },
    {
      path: '/active/page/yybzym',
      name: 'Tencent',
      component: resolve => require(["../components/activePage/yybZym"], resolve),
    },
    {
      path: '/active/page/yybkj',
      name: 'Tencent',
      component: resolve => require(["../components/activePage/yybkj"], resolve),
    },
    {
      path: '/active/page/activeAs',
      name: 'Tencent',
      component: resolve => require(["../components/activePage/activeAs"], resolve),
    },
    {
      path: '/tencent/activity',
      name: 'Tencent',
      component: resolve => require(["../components/activePage/yybFh"], resolve),
    },
    {
      path: '/active/page/yybfl',
      name: 'Tencent',
      component: resolve => require(["../components/activePage/yybFl"], resolve),
    },
    {
      path: '/active/page/activeSh',
      name: 'Tencent',
      component: resolve => require(["../components/activePage/activeSh"], resolve),
    },
    {
      path: '/active/page/activeXl',
      name: 'Tencent',
      component: resolve => require(["../components/activePage/activeXl"], resolve),
    },
    {
      path: '/active/page/activeBs',
      name: 'Tencent',
      component: resolve => require(["../components/activePage/activeBs"], resolve),
    },
    {
      path: '/active/page/activetc',
      name: 'Tc',
      component: resolve => require(["../components/activePage/activeTc"], resolve),
    },
    {
      path: '/active/page/activexly',
      name: 'Tencent',
      component: resolve => require(["../components/activePage/activexly"], resolve),
    },
    {
      path: '/active/page/yybsfl',
      name: 'Tencent',
      component: resolve => require(["../components/activePage/yybSfl"], resolve),
    },
    {
      path: '/active/page/yybgq',
      name: 'Tencent',
      component: resolve => require(["../components/activePage/yybgq"], resolve),
    },
    {
      path: '/active/page/yclk',
      name: 'Tencent',
      component: resolve => require(["../components/activePage/yclk"], resolve),
    },
    {
      path: '/active/page/ljkj',
      name: 'Tencent',
      component: resolve => require(["../components/activePage/ljkj"], resolve),
    },
    {
      path: '/active/page/yybzq',
      name: 'Tencent',
      component: resolve => require(["../components/activePage/yybzq"], resolve),
    },
    {
      path: '/active/page/yybyq',
      name: 'Tencent',
      component: resolve => require(["../components/activePage/yybyq"], resolve),
    },
    {
      path: '/active/page/yybhfl',
      name: 'Tencent',
      component: resolve => require(["../components/activePage/yybhfl"], resolve),
    },
    {
      path: '/active/page/yybmz',
      name: 'Tencent',
      component: resolve => require(["../components/activePage/yybmz"], resolve),
    },
    {
      path: '/active/page/yybxr',
      name: 'Tencent',
      component: resolve => require(["../components/activePage/yybxr"], resolve),
    },
    {
      path: '/active/page/yybjs',
      name: 'Tencent',
      component: resolve => require(["../components/activePage/yybjs"], resolve),
    },
    {
      path: '/active/page/qdds',
      name: 'Tencent',
      component: resolve => require(["../components/activePage/qdds"], resolve),
    },
    {
      path: '/active/page/ddbx',
      name: 'Tencent',
      component: resolve => require(["../components/activePage/ddbx"], resolve),
    },
    {
      path: '/active/page/qdfl',
      name: 'Tencent',
      component: resolve => require(["../components/activePage/qdfl"], resolve),
    },
    {
      path: '/active/page/wyfl',
      name: 'Tencent',
      component: resolve => require(["../components/activePage/wyfl"], resolve),
    },
    {
      path: '/active/page/asbxx',
      name: 'Tencent',
      component: resolve => require(["../components/activePage/asbxx"], resolve),
    },
    {
      path: '/active/page/asbxl',
      name: 'Tencent',
      component: resolve => require(["../components/activePage/asbxl"], resolve),
    },
    {
      path: '/recom',
      name: 'Recom',
      component: resolve => require(["../components/Recom"], resolve),
    },
    {
      path: '/classification',
      name: 'Classification',
      component: resolve => require(["../components/Classification"], resolve),
    },
    {
      path: '/mine',
      name: 'Mine',
      component: resolve => require(["../components/Mine"], resolve),
    },
    {
      path: '/shopDetail/:productId',
      name: 'ShopDetail',
      component: resolve => require(["../components/common/ShopDetail"], resolve),
    },
    // 优惠券
    {
      path: '/couponList/:couponId',
      name: 'CouponList',
      component: resolve => require(["../components/coupons/couponList.vue"], resolve),
    },
    {
      path: '/shopCard',
      name: 'ShopCard',
      component: resolve => require(["../components/common/ShopCard.vue"], resolve),
    },
    {
      path: '/shopCardHome',
      name: 'ShopCardHome',
      component: resolve => require(["../components/common/ShopCardHome.vue"], resolve),
    },
    {
      path: '/shopAddress',
      name: 'ShopAddress',
      component: resolve => require(["../components/common/ShopAddress.vue"], resolve),
    },
    {
      path: '/policy',
      name: 'Policy',
      component: resolve => require(["../components/common/Policy.vue"], resolve),
    },
    {
      path: '/agreement',
      name: 'Agreement',
      component: resolve => require(["../components/common/Agreement.vue"], resolve),
    },
    {
      path: '/shopAddressList',
      name: 'ShopAddressList',
      component: resolve => require(["../components/common/ShopAddressList"], resolve),
    },
    {
      path: '/shopPay',
      name: 'ShopPay',
      component: ShopPay
      // component: ()=>import('../components/common/ShopPay.vue')
    },
    {
      path: '/payDialog',
      name: 'PayDialog',
      component: () => import('../components/common/PayDialog.vue')
    },
    {
      path: '/SelectShop',
      name: 'SelectShop',
      component: () => import('../components/common/SelectShop.vue')
    },
    {
      path: '/coupons',
      name: 'Coupons',
      component: resolve => require(["../components/common/Coupons"], resolve),
    },
    {
      path: '/CouponRecom',
      name: 'CouponRecom',
      component: resolve => require(["../components/common/CouponRecom"], resolve),
    },
    {
      path: '/oldOrder',
      name: 'OldOrder',
      component: resolve => require(["../components/common/OldOrder"], resolve),
    },
    {
      path: '/orderAll',
      name: 'OrderAll',
      component: resolve => require(["../components/common/OrderAll"], resolve),
    },
    {
      path: '/order/search',
      name: 'OrderSearch',
      component: resolve => require(["../components/myOrder/myOrder"], resolve),
    },
    {
      path: '/order/myOrder',
      name: 'MyOrder',
      component: resolve => require(["../components/myOrder/myOrder"], resolve),
    },
    {
      path: '/order/query',
      name: 'MyOrder',
      component: resolve => require(["../components/myOrder/myOrder"], resolve),
    },
    {
      path: '/order/OrderDetail/:orderId',
      name: 'OrderDetail',
      component: resolve => require(["../components/myOrder/OrderDetail"], resolve),
    },
    {
      path: '/refundDetail',
      name: 'RefundDetail',
      component: resolve => require(["../components/public/RefundDetail.vue"], resolve),
    },
    {
      path: '/afteRefundDetail',
      name: 'AfteRefundDetail',
      component: resolve => require(["../components/public/AfteRefundDetail.vue"], resolve),
    },
    {
      path: '/shopCollection',
      name: 'ShopCollection',
      component: resolve => require(["../components/common/ShopCollection"], resolve),
    },
    {
      path: '/afterSalesBounced',
      name: 'AfterSalesBounced',
      component: resolve => require(["../components/mine/AfterSalesBounced"], resolve),
    },
    {
      path: '/afterSales',
      name: 'AfterSales',
      component: resolve => require(["../components/mine/AfterSales"], resolve),
    },
    {
      path: '/afterSalesDetail',
      name: 'AfterSalesDetail',
      component: resolve => require(["../components/mine/AfterSalesDetail"], resolve),
    },
    // {
    //   path: '/afternegotiation',
    //   name: 'Afternegotiation',
    //   component: resolve => require(["../components/mine/Afternegotiation"], resolve),
    // },
    {
      path: '/orderDetail',
      name: 'OrderDetail',
      component: resolve => require(["../components/mine/OrderDetail"], resolve),
    },
    {
      path: '/order/:orderId',
      name: 'OrderInfo',
      component: resolve => require(["../components/mine/OrderDetail"], resolve),
    },
    {
      path: '/oldOrderDetail',
      name: 'OldOrderDetail',
      component: resolve => require(["../components/common/OldOrderDetail.vue"], resolve),
    },
    {
      path: '/applyAfterSales',
      name: 'ApplyAfterSales',
      component: resolve => require(["../components/mine/ApplyAfterSales"], resolve),
    },
    {
      path: '/customerService',
      name: 'CustomerService',
      component: resolve => require(["../components/mine/CustomerService"], resolve),
    },
    {
      path: '/myEvaluation',
      name: 'MyEvaluation',
      component: resolve => require(["../components/mine/MyEvaluation"], resolve),
    },
    {
      path: '/oldLogistics',
      name: 'OldLogistics',
      component: resolve => require(["../components/common/OldLogistics"], resolve),
    },
    {
      path: '/logistics/:orderId',
      name: 'Logistics',
      component: resolve => require(["../components/mine/Logistics"], resolve),
    },
    {
      path: '/comments',
      name: 'Comments',
      component: resolve => require(["../components/mine/Comments"], resolve),
    },
    {
      path: '/payStatus',
      name: 'PayStatus',
      component: resolve => require(["../components/public/PayStatus"], resolve),
    },
    {
      path: '/login',
      name: 'Login',
      component: resolve => require(["../components/Login"], resolve),
    },
    {
      path: '/logOut',
      name: 'LogOut',
      component: resolve => require(["../components/LogOut"], resolve),
    },
    {
      path: '/error',
      name: 'Error',
      component: resolve => require(["../components/Error"], resolve),
    },
    // 购物车
    {
      path: '/shoppingCart',
      name: 'ShoppingCart',
      component: resolve => require(["../components/shoppingCart/ShoppingCart.vue"], resolve),
    },
    //用户提现(51公积金用)
    {
      path: '/points/exchange',
      name: 'PointsExchange',
      component: resolve => require(["../components/common/CashOut.vue"], resolve),
    },
    // {
    //   path: '/cannelorfinish',
    //   name: 'Cannelorfinish',
    //   component: resolve => require(["../components/common/Cannelorfinish"], resolve),
    // },
  ]
})

//vue 项目在路由切换的时候调用
route.beforeEach(function (to, from, next) {
  //localStorage.getItem('configInfo') ? document.title = JSON.parse( sessionStorage.getItem('configInfo') ).app_name : ''
  //console.log('url1:', document.URL);

  // 不是详情或地址来的特殊处理
  // if ((to.name === "ShopPay" && from.name != "ShopDetail") || ( to.name === "ShopPay" && from.name != "ShopAddressList" )) {
  // if (to.name === "ShopPay" && from.name != "ShopDetail") {
  //   localStorage.setItem("detailId", "1")
  // } else {
  //   localStorage.removeItem("detailId")
  // }
  // 从弹框到订单列表存值，
  localStorage.removeItem("fromPaydialog")

  if ((to.name === "OrderAll")) {
    if (from.name == "PayDialog") {
      localStorage.setItem("fromPaydialog", "1")
    } else if (from.name == null) {
      localStorage.setItem("fromPaydialog", "2")
    }
  }
  // console.log(history.length,from.name,"-->",to.name)
  //从payDialog回退至详情页
  if (to.name == "ShopDetail" && (from.name == "PayDialog" || from.name == "ShopPay")) {
    sessionStorage.setItem("need-refresh", "1");
    // console.log("need-refresh")
  } else {
    sessionStorage.removeItem("need-refresh")
  }

  //百度统计
  if (_hmt) {
    if (to.path) {
      _hmt.push(['_trackPageview', to.fullPath]);
    }
  }

  setTimeout(function () {
    next();
    //统计代码开始
    try {
      let app_id = localStorage.getItem("configInfo") ? JSON.parse(localStorage.getItem("configInfo")).app_id : 0;
      let cp_uid = localStorage.getItem("configInfo") ? JSON.parse(localStorage.getItem("configInfo")).cp_uid : 0;
      let app_type = localStorage.getItem("configInfo") ? JSON.parse(localStorage.getItem("configInfo")).app_type : 0;
      xa.registerPage({
        app_id: app_id,
        cp_uid: cp_uid,
        app_type: app_type,
      });
      xa.quick("autoTrackSinglePage"); // after the next(); statement
    } catch (e) { }
    //统计代码结束

  }, 0);
});

route.onError((err) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = err.message.match(pattern);
  if (isChunkLoadFailed) {
    let chunkBool = sessionStorage.getItem('chunkError');
    let nowTimes = Date.now();
    if (chunkBool === null || chunkBool && nowTimes - parseInt(chunkBool) > 60000) {//路由跳转报错,href手动跳转
      sessionStorage.setItem('chunkError', 'reload');
      const targetPath = route.history.pending.fullPath;
      window.location.href = window.location.origin + targetPath;
    } else if (chunkBool === 'reload') { //手动跳转后依然报错,强制刷新
      sessionStorage.setItem('chunkError', Date.now());
      window.location.reload(true);
    }
  }
})

export default route



// WEBPACK FOOTER //
// ./src/router/index.js